import { render, staticRenderFns } from "./activities-row.vue?vue&type=template&id=475bcf83&scoped=true&"
import script from "./activities-row.vue?vue&type=script&lang=js&"
export * from "./activities-row.vue?vue&type=script&lang=js&"
import style0 from "./activities-row.vue?vue&type=style&index=0&id=475bcf83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475bcf83",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('475bcf83')) {
      api.createRecord('475bcf83', component.options)
    } else {
      api.reload('475bcf83', component.options)
    }
    module.hot.accept("./activities-row.vue?vue&type=template&id=475bcf83&scoped=true&", function () {
      api.rerender('475bcf83', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/pageParts/activities-row.vue"
export default component.exports